import { z } from "zod";

export const companySchema = () => {
  return z.object({
    corporate_name: z.string().optional().nullable(),
    name: z.string().min(1),
    cnpj: z.string().optional().nullable(),
    rank: z.number().optional(),
    description: z.string().optional().nullable(),
    plans: z.array(z.number()).min(1),
    category: z.string().optional(),
    exclusive: z.boolean().optional(),
    status: z.string().optional(),
    approved_terms_date: z.any().optional().nullable(),
    created_by_agreement: z.boolean().optional(),
    approved_data: z.boolean().optional(),
    active: z.boolean().optional(),
    owner: z.string().optional().nullable(),
    telephone: z.string().optional().nullable(),
    cellphone: z.string().optional().nullable(),
    email: z.string().email().optional().nullable(),
    site: z.string().optional().nullable(),
    logo: z.any().optional().nullable(),
    cover_photo: z.any().optional(),
  });
};

export type CompanyFormValues = z.infer<ReturnType<typeof companySchema>>;
